import './Footer.css'

/* ── Icônes paiement SVG ── */
const IconVisa = () => (
  <svg viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="32" rx="4" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.75"/>
    <text x="7" y="21" fontFamily="Inter,sans-serif" fontSize="13" fontWeight="800" fill="#fff" letterSpacing="0.5">VISA</text>
  </svg>
)

const IconMastercard = () => (
  <svg viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="32" rx="4" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.75"/>
    <circle cx="20" cy="16" r="8" fill="#EB001B" opacity="0.9"/>
    <circle cx="32" cy="16" r="8" fill="#F79E1B" opacity="0.9"/>
    <path d="M26 9.5a8 8 0 0 1 0 13A8 8 0 0 1 26 9.5z" fill="#FF5F00"/>
  </svg>
)

const IconPaypal = () => (
  <svg viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="32" rx="4" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.15)" strokeWidth="0.75"/>
    <text x="7" y="21" fontFamily="Inter,sans-serif" fontSize="11" fontWeight="700" fill="#fff">PayPal</text>
  </svg>
)

/* ── Icônes animaux SVG ── */
const IconDog = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 11C3 11 2 12 2 13.5S3 16 4.5 16H6v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h1c1.5 0 3-1 3-3V9l2-4h-3l-1 2c-.5-.1-1-.2-1.5-.2C9 6.8 6 8 5 10l-.5 1z"/>
  </svg>
)
const IconCat = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 5v4c0 4.4 3.1 7 7 7s7-2.6 7-7V5l-2.5 2.5A6.5 6.5 0 0 0 12 7a6.5 6.5 0 0 0-4.5.5L5 5z"/>
    <path d="M9 19v2M15 19v2"/>
  </svg>
)
const IconBird = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.5 5.5C19 3 16 2.5 14 4c-1.2.9-2 2.5-2 4 0 1 .3 2 .8 2.7L6 17H4v2h4l1.5-1.5"/>
    <path d="M12.8 10.7L18 8l1.5 3-2.5.5"/>
  </svg>
)
const IconReptile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12c0-2 1.5-3.5 4-4 1.5-.3 3 .2 4 1"/>
    <path d="M10 9c2-1.5 5-1 6.5 1S18 14 16 15.5"/>
    <path d="M16 15.5c-1 1-2 1.5-4 1.5s-3-.5-3-2 .5-3 1-4"/>
  </svg>
)
const IconRabbit = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.5 3C7 4.5 7 6 8 7.5M16.5 3C17 4.5 17 6 16 7.5"/>
    <path d="M6 8c-1.5.5-3 2-3 4 0 1.5 1 2.5 2.5 3V18a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3c1.5-.5 2.5-1.5 2.5-3 0-2-1.5-3.5-3-4H6z"/>
  </svg>
)
const IconRodent = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="14" rx="6" ry="5"/>
    <path d="M7 10C6 7 7 4 9.5 3.5S14 5 13 8"/>
    <path d="M17 10c1-3 0-5-2-6"/>
  </svg>
)
const IconFish = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12c0-3-2.5-5.5-5.5-5.5S9 9 9 12s2.5 5.5 5.5 5.5S20 15 20 12z"/>
    <path d="M9 12L4 7l1 5-1 5 5-5z"/>
  </svg>
)
const IconHorse = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 21v-5l1.5-4L10 9l4 .5 3.5-4 1 3.5-1.5 2V21"/>
    <path d="M10 21v-4M16.5 21v-4"/>
  </svg>
)

/* ── Icônes contact SVG ── */
const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-6.5-5.2-6.5-10.5a6.5 6.5 0 0 1 13 0C18.5 15.8 12 21 12 21z"/>
    <circle cx="12" cy="10.5" r="2"/>
  </svg>
)
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>
  </svg>
)
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <path d="M2 8l10 7 10-7"/>
  </svg>
)
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M12 7v5l3 3"/>
  </svg>
)

const FOOTER_CATS = [
  { Icon: IconDog,     label: 'Chiens'   },
  { Icon: IconCat,     label: 'Chats'    },
  { Icon: IconBird,    label: 'Oiseaux'  },
  { Icon: IconReptile, label: 'Reptiles' },
  { Icon: IconRabbit,  label: 'Lapins'   },
  { Icon: IconRodent,  label: 'Rongeurs' },
  { Icon: IconFish,    label: 'Poissons' },
  { Icon: IconHorse,   label: 'Chevaux'  },
]

const CONTACTS = [
  { Icon: IconPin,   text: '15 Rue de la Paix, Paris 75001' },
  { Icon: IconPhone, text: '+33 07 57 75 00 92' },
  { Icon: IconMail,  text: 'animauxdecompagnie@animauxpouradoptiondelafrance.com' },
  { Icon: IconClock, text: 'Lun–Ven : 9h–18h' },
]

export default function Footer({ onCategoryClick = () => {} }) {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-inner">

          {/* ── Colonne 1 : Logo + description + paiements ── */}
          <div className="footer-col footer-col-brand">
            <div className="footer-logo">
              <img
                className="footer-logo-img"
                src={require('../../assets/monlogo.jpeg')}
                alt="Animaux pour Adoption"
                onError={(e) => { e.target.style.display = 'none' }}
              />
              <div className="footer-logo-txt">
                <span className="footer-logo-main">Animaux pour Adoption</span>
                <span className="footer-logo-sub">de la France</span>
              </div>
            </div>
            <p className="footer-desc">
              La première plateforme française de mise en relation entre éleveurs certifiés
              et familles. Animaux vaccinés, vérifiés et livrés partout dans le monde.
            </p>

            {/* Paiements */}
            <div className="footer-pay-methods">
              <div className="footer-pay-label">Paiements acceptés</div>
              <div className="footer-pay-icons-row">
                <IconVisa />
                <IconMastercard />
                <IconPaypal />
              </div>
            </div>
          </div>

          {/* ── Colonne 2 : Catégories avec icônes SVG ── */}
          <div className="footer-col">
            <div className="footer-col-title">Catégories</div>
            <ul className="footer-links">
              {FOOTER_CATS.map(({ Icon, label }) => (
                <li key={label}>
                  <button className="footer-link footer-link-cat" onClick={() => onCategoryClick(label)}>
                    <span className="footer-cat-icon"><Icon /></span>
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Colonne 3 : Liens utiles ── */}
          <div className="footer-col">
            <div className="footer-col-title">Liens utiles</div>
            <ul className="footer-links">
              {[
                'Comment ça marche ?',
                'Éleveurs certifiés',
                "Guide de l'adoption",
                'Conseils vétérinaires',
                'Livraison internationale',
                'Assurance animale',
                'Espace vendeur',
                'Blog & actualités',
              ].map(l => (
                <li key={l}><button className="footer-link">{l}</button></li>
              ))}
            </ul>
          </div>

          {/* ── Colonne 4 : Contact + Newsletter ── */}
          <div className="footer-col">
            <div className="footer-col-title">Contact</div>
            <ul className="footer-links footer-contacts">
              {CONTACTS.map(({ Icon, text }) => (
                <li key={text}>
                  <span className="footer-contact-item">
                    <Icon />
                    {text}
                  </span>
                </li>
              ))}
            </ul>

            <div className="footer-nl-title">Newsletter</div>
            <div className="footer-nl">
              <input
                className="footer-nl-input"
                type="email"
                placeholder="votre@email.fr"
                aria-label="Email newsletter"
              />
              <button className="footer-nl-btn">S'abonner</button>
            </div>
            <p className="footer-nl-note">
              Recevez les nouvelles annonces en avant-première.
            </p>
          </div>

        </div>
      </div>

      {/* ── Barre basse ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <div className="footer-copy">
            © {currentYear} Animaux pour Adoption de la France. Tous droits réservés.
          </div>
          <div className="footer-legal">
            {['Mentions légales', 'CGV', 'Politique de confidentialité', 'Cookies'].map((l, i) => (
              <span key={l}>
                <button className="footer-legal-link">{l}</button>
                {i < 3 && <span className="footer-legal-sep">·</span>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}